module.exports = __webpack_public_path__ + "static/media/obgyn-image2@2x.3056a95b.png";